import { render, staticRenderFns } from "./DatatableInPage.vue?vue&type=template&id=0dc439da"
import script from "./DatatableScriptInPage.js?vue&type=script&lang=js&external"
export * from "./DatatableScriptInPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports